export function fitBounds(props, map, resellers, adjustPosition = true) {
    if (props.showingInfoWindow || Object.keys(props.selectedMarker).length || !resellers.length || !map) return;

    let minLat = resellers.reduce(function (prev, current) {
        return (prev.lat < current.lat) ? prev : current
    }).lat;

    let maxLat = resellers.reduce(function (prev, current) {
        return (prev.lat > current.lat) ? prev : current
    }).lat;

    let minLng = resellers.reduce(function (prev, current) {
        return (prev.lng < current.lng) ? prev : current
    }).lng;

    let maxLng = resellers.reduce(function (prev, current) {
        return (prev.lng > current.lng) ? prev : current
    }).lng;

    const bounds = new google.maps.LatLngBounds()

    if (resellers.length === 1 || (minLat === maxLat && minLng === maxLng)) {
        minLat -= 1.1;
        minLng -= (adjustPosition ? 4 : 1.1);
        maxLat += 1.1;
        maxLng += 1.1;
    } else if(adjustPosition) {
        let zoom = map.getZoom();

        if (props.selectedCountry === '') {
            minLng -= 10;
            maxLng -= 10;
        }

        if (zoom <= 4 && props.selectedCountry !== '') {
            minLng -= 6;
        }
        else if (zoom <= 6 && props.selectedCountry !== '') {
            minLng -= 2;
        }
        else if (zoom <= 8 && props.selectedCountry !== '') {
            minLng -= 16;
        }
        else if (zoom <= 10 && props.selectedCountry !== '') {
            minLng -= 0.2;
        }
    }

    bounds.extend({
        lat: minLat,
        lng: minLng
    });

    bounds.extend({
        lat: maxLat,
        lng: maxLng
    });

    map.fitBounds(bounds);
}
